export default __webpack_public_path__ + "static/usa-today-grey-3acecf04f5924ce259ef9b152d58bf8b.svg";